import { z } from 'zod';

/** Job Description content (spec §7.1). */

export const jdFactSchema = z.object({
  label: z.string().min(1).max(60),
  value: z.string().min(1).max(220),
});

export const JD_FACT_LABELS_EN = [
  'Client',
  'Location & work model',
  'Start',
  'Duration',
  'Workload',
  'Rate',
  'Languages',
  'Contract',
] as const;

export const JD_FACT_LABELS_DE = [
  'Kunde',
  'Standort & Arbeitsmodell',
  'Start',
  'Laufzeit',
  'Auslastung',
  'Vergütung',
  'Sprachen',
  'Vertragsart',
] as const;

export const JD_RATE_FACT_INDEX = 5;

export const jdContactSchema = z
  .object({
    name: z.string().optional(),
    role: z.union([z.string(), z.object({ en: z.string(), de: z.string() })]).optional(),
    email: z.string().optional(),
    phone: z.string().optional(),
  })
  .partial();

export const jdContentSchema = z
  .object({
    lang: z.enum(['en', 'de']).default('en'),
    ref: z.string().regex(/^DC-J-\d{4}-\d{4,}$/, 'ref must look like DC-J-YYYY-NNNN'),
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'date must be YYYY-MM-DD'),
    status: z.string().max(80).optional(),
    title: z.string().min(3).max(160),
    subtitle: z.string().max(200).optional(),
    intro: z.string().max(1200).optional(),
    facts: z.array(jdFactSchema).length(8, 'facts must contain exactly 8 entries in the fixed order'),
    about: z.union([z.string(), z.array(z.string().min(1))]).optional(),
    responsibilities: z.array(z.string().min(1)).min(1).max(10),
    mustHave: z.array(z.string().min(1)).min(1).max(10),
    niceToHave: z.array(z.string().min(1)).max(8).optional(),
    stack: z.union([z.array(z.tuple([z.string(), z.string()])).max(8), z.string()]).optional(),
    team: z.union([z.string().min(1), z.array(z.string().min(1)).min(1)]),
    process: z.array(z.string().min(1)).min(1).max(8),
    applyText: z.string().max(600).optional(),
    applyEmail: z.string().email().optional(),
    contact: jdContactSchema.optional(),
  })
  .strict();

export type JdContent = z.infer<typeof jdContentSchema>;
export type JdContentInput = z.input<typeof jdContentSchema>;
export type JdFact = z.infer<typeof jdFactSchema>;

export const JD_TEAM_PHRASES = {
  en: ["as part of the client's team under the coordination of data-claw.de"],
  de: ['unter koordination von data-claw.de', 'unter der koordination von data-claw.de'],
} as const;
